import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phonenumber' })
export class PhoneNumberPipe implements PipeTransform {
  transform(input: string): any {
    if (input === '' || input === null || input === undefined) {
      return '';
    }
    if (input.charAt(0) !== '0' && input.charAt(0) !== '+') {
      return '+' + input;
    }
    return input;
  }
}
